// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OtherTiles_wrapper__BX7Yu","section":"OtherTiles_section___1Zzp","title":"OtherTiles_title__4Oy8r"};